import { getAxiosInstance } from '../client';
/** Query API functions for upload domain */
export const uploadQueries = {
    /**
     * GET /upload/:userId/profileImage
     * Returns the profile image as a Blob
     */
    getProfileImage: async (userId) => {
        const response = await getAxiosInstance().get(`/upload/${userId}/profileImage`, {
            responseType: 'blob',
            validateStatus: (status) => status === 200 || status === 404,
        });
        if (response.status === 404) {
            return null;
        }
        return response.data;
    },
    /**
     * GET /upload/byUserId/:userId
     * Returns all file uploads for a user
     */
    getByUserId: async (userId) => {
        const response = await getAxiosInstance().get(`/upload/byUserId/${userId}`);
        return response.data;
    },
    /**
     * GET /upload/:filename (full URL)
     * Downloads a file as a Blob
     */
    downloadFile: async (filename) => {
        const response = await getAxiosInstance().get(`/upload/${filename}`, {
            responseType: 'blob',
        });
        return response.data;
    },
};
/** Query keys for upload domain - use with TanStack Query */
export const uploadKeys = {
    all: () => ['upload'],
    profileImages: () => [...uploadKeys.all(), 'profileImage'],
    profileImage: (userId) => [...uploadKeys.profileImages(), userId],
    byUserId: (userId) => [...uploadKeys.all(), 'byUserId', userId],
    /** One stored file's bytes, by its stored name (`downloadFile`). */
    file: (filename) => [...uploadKeys.all(), 'file', filename],
};
//# sourceMappingURL=upload.queries.js.map